import { map } from 'rxjs/operators';
import AUTH_EXCEPTIONS from '../../../Shared/Infrastructure/Exception/APIv4AuthExceptionMap';
import APIv4ResponseProcessor from '../../../Shared/Infrastructure/Http/APIv4ResponsePipeProcessor';
const ENDPOINT_LOGIN = '/oauth/access_token';
class APIv4AuthCredentialsRepository {
  constructor(context, httpClient) {
    this.context = context;
    this.httpClient = httpClient;
    this.oauthEndpoint = `${this.context.baseUrl}${ENDPOINT_LOGIN}`;
  }
  findByCustomer(clientId, username, password) {
    const credentials = JSON.stringify({
      clientID: clientId,
      grant_type: 'password',
      rand: '',
      user_credential: password,
      userID: username
    });
    return this.httpClient.post(this.oauthEndpoint, `request_data=${credentials}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).pipe(map(({
      response_data
    }) => ({
      accessToken: response_data.access_token,
      expiresIn: response_data.expires_in
    })));
  }
  getM2MToken(username, password, clientId) {
    const credentials = JSON.stringify({
      clientID: clientId,
      grant_type: 'password',
      rand: '',
      user_credential: password,
      userID: username
    });
    return this.httpClient.post(this.oauthEndpoint, `request_data=${credentials}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).pipe(map(({
      response_data
    }) => ({
      accessToken: response_data.access_token,
      expiresIn: response_data.expires_in
    })));
  }
  findByStore(clientId) {
    const credentials = JSON.stringify({
      delegate_userID: clientId,
      clientID: this.context.apiKey,
      grant_type: 'password',
      user_credential: ''
    });
    return this.httpClient.post(this.oauthEndpoint, `request_data=${credentials}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).pipe(APIv4ResponseProcessor.handle(AUTH_EXCEPTIONS), map(({
      response_data
    }) => ({
      accessToken: response_data.access_token,
      expiresIn: response_data.expires_in
    })));
  }
}

export { APIv4AuthCredentialsRepository as default };